<template>
  <div class="centralized-issue-status">
    <div class="centralized-issue-status__status">
      <div class="centralized-issue-status__status__indicator" :style='`fill:${statusConfig.color}`'>
        <div class="centralized-issue-status__status__indicator__icon" :is='statusConfig.type'/>
      </div>
      <div class="centralized-issue-status__status__label" :title='displayLabel !== label ? label : null'>{{ displayLabel }}</div>
    </div>
  </div>
</template>

<script>
import statusNew from '@/assets/icons/staus/new.svg?inline';
import statusInProgress from '@/assets/icons/staus/progress.svg?inline';
import statusFixed from '@/assets/icons/staus/fixed.svg?inline';

export default {
  name: 'CentralizedIssueStatus',
  components: {statusNew, statusInProgress, statusFixed},
  data() {
    return {
      statuses: {
        new: { type: statusNew, color: '#e0ad42'},
        open: { type: statusInProgress, color: '#2459d5'},
        fixed: { type: statusFixed, color: '#2baf69'},
        suppressed: { type: statusFixed, color: '#777777'},
        temporaryException: { type: statusInProgress, color: '#b98a2b'},
      },
    };
  },
  props: {
    /** Status key: new / open / fixed / suppressed / temporaryException. */
    status: {
      required: true,
    },
    /** Narrow spots (table cells): use the short label when one exists; the full one shows on hover. */
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusConfig() {
      return this.statuses[this.status] || this.statuses.open;
    },
    label() {
      const key = `centralized.issues.status.${this.status}`;
      return this.$te(key) ? this.$t(key) : this.status;
    },
    displayLabel() {
      const shortKey = `centralized.issues.status.short.${this.status}`;
      return this.compact && this.$te(shortKey) ? this.$t(shortKey) : this.label;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.centralized-issue-status {
  display: flex;
  flex-direction: row;

  &__status {
    display: flex;
    flex-direction: row;
    align-content: center;

    &__indicator {
      margin-top: $space-1;

      &__icon {
        height: rem(20);
      }
    }

    &__label {
      font-family: $font-family-medium;
      font-size: $font-size-base;
      text-transform: capitalize;
      margin-left: $space-1;
      color: var(--text-secondary);
      white-space: nowrap;
    }
  }
}
</style>
